var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "add-owner-view" },
    [
      _vm.isMobile
        ? _c("TopProgressBar", {
            attrs: { prevStep: "partner-business", "is-back-shown": true }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ob-step-container -helper--flex column" },
        [
          _c("div", { staticClass: "title" }, [_vm._v("Add another owner")]),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              class: "-helper--flex column",
              attrs: { id: "v-form" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.submitForm.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "-helper--flex column form-wrapper-1" },
                [
                  _c(
                    "label",
                    {
                      ref: "ownerDetailsSection",
                      staticClass: "form-section-header"
                    },
                    [_vm._v("Owner details")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-row" },
                    [
                      _c("v-text-field", {
                        ref: "firstName",
                        attrs: {
                          dense: "",
                          filled: "",
                          rounded: "",
                          "validate-on-blur": "",
                          autocomplete: "null",
                          type: "text",
                          rules: _vm.fieldRules.firstName,
                          "error-messages": _vm.formFieldsErrors.firstName,
                          id: "firstName"
                        },
                        on: {
                          focus: function($event) {
                            return _vm.clearFieldError("firstName")
                          }
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "label",
                            fn: function() {
                              return [
                                _c("p", { staticClass: "input-legend" }, [
                                  _vm._v(_vm._s(_vm.$t("intro.firstName")))
                                ])
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "message",
                            fn: function(ref) {
                              var message = ref.message
                              var key = ref.key
                              return [
                                _c("span", {
                                  key: key,
                                  attrs: { id: "firstNameMessage" },
                                  domProps: { innerHTML: _vm._s(message) }
                                })
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.formData.firstName,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "firstName", $$v)
                          },
                          expression: "formData.firstName"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: {
                          dense: "",
                          filled: "",
                          rounded: "",
                          "validate-on-blur": "",
                          autocomplete: "null",
                          rules: _vm.fieldRules.lastName,
                          "error-messages": _vm.formFieldsErrors.lastName,
                          id: "lastName"
                        },
                        on: {
                          focus: function($event) {
                            return _vm.clearFieldError("lastName")
                          }
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "label",
                            fn: function() {
                              return [
                                _c("p", { staticClass: "input-legend" }, [
                                  _vm._v(_vm._s(_vm.$t("intro.lastName")))
                                ])
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "message",
                            fn: function(ref) {
                              var message = ref.message
                              var key = ref.key
                              return [
                                _c("span", {
                                  key: key,
                                  attrs: { id: "lastNameMessage" },
                                  domProps: { innerHTML: _vm._s(message) }
                                })
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.formData.lastName,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "lastName", $$v)
                          },
                          expression: "formData.lastName"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-row" },
                    [
                      _c("v-text-field", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: "+1 (###) ###-####",
                            expression: "'+1 (###) ###-####'"
                          }
                        ],
                        ref: "phoneField",
                        attrs: {
                          dense: "",
                          filled: "",
                          rounded: "",
                          "validate-on-blur": "",
                          autocomplete: "null",
                          type: "tel",
                          rules: _vm.fieldRules.phoneNumber,
                          "error-messages": _vm.formFieldsErrors.phoneNumber,
                          id: "phoneNumber"
                        },
                        on: {
                          focus: function($event) {
                            return _vm.clearFieldError("phoneNumber")
                          }
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "label",
                            fn: function() {
                              return [
                                _c("p", { staticClass: "input-legend" }, [
                                  _vm._v(_vm._s(_vm.$t("register.label")))
                                ])
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "message",
                            fn: function(ref) {
                              var message = ref.message
                              var key = ref.key
                              return [
                                _c("span", {
                                  key: key,
                                  attrs: { id: "phoneMessage" },
                                  domProps: { innerHTML: _vm._s(message) }
                                })
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.formData.phoneNumber,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "phoneNumber", $$v)
                          },
                          expression: "formData.phoneNumber"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "v-text-field",
                        {
                          ref: "emailInput",
                          attrs: {
                            dense: "",
                            filled: "",
                            rounded: "",
                            rules: _vm.fieldRules.email,
                            "error-messages":
                              _vm.formFieldsErrors.email ||
                              _vm.formFieldsErrors.defaultError,
                            autocomplete: "null",
                            type: "email",
                            "validate-on-blur": "",
                            id: "email",
                            disabled: !!_vm.uboId
                          },
                          on: {
                            focus: function($event) {
                              return _vm.clearFieldError("email")
                            }
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "message",
                              fn: function(ref) {
                                var message = ref.message
                                var key = ref.key
                                return [
                                  _c("span", {
                                    key: key,
                                    attrs: { id: "emailMessage" },
                                    domProps: { innerHTML: _vm._s(message) }
                                  })
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.formData.email,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "email", $$v)
                            },
                            expression: "formData.email"
                          }
                        },
                        [
                          _c("template", { slot: "label" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("intro.email")) +
                                "\n          "
                            )
                          ])
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "horizontal-divider" }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      ref: "ownerIdentitySection",
                      staticClass: "form-section-header"
                    },
                    [_vm._v("Owner identity details")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-row" },
                    [
                      _c(
                        "div",
                        { staticClass: "ssn" },
                        [
                          _c("v-text-field", {
                            directives: [
                              {
                                name: "mask",
                                rawName: "v-mask",
                                value: "###-##-####",
                                expression: "'###-##-####'"
                              }
                            ],
                            attrs: {
                              dense: "",
                              filled: "",
                              rounded: "",
                              "validate-on-blur": "",
                              autocomplete: "null",
                              type: _vm.flags.isSsnShown ? "tel" : "password",
                              "append-icon": _vm.flags.isSsnShown
                                ? _vm.icons.mdiEyeInternal
                                : _vm.icons.mdiEyeOffInternal,
                              rules: _vm.fieldRules.ssn,
                              "error-messages": _vm.formFieldsErrors.ssn,
                              id: "ssn"
                            },
                            on: {
                              focus: function($event) {
                                return _vm.clearFieldError("ssn")
                              },
                              "click:append": function($event) {
                                _vm.flags.isSsnShown = !_vm.flags.isSsnShown
                              }
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "label",
                                fn: function() {
                                  return [
                                    _c("p", { staticClass: "input-legend" }, [
                                      _vm._v(_vm._s(_vm.$t("kyc.ssn")))
                                    ])
                                  ]
                                },
                                proxy: true
                              },
                              {
                                key: "message",
                                fn: function(ref) {
                                  var message = ref.message
                                  var key = ref.key
                                  return [
                                    _c("span", {
                                      key: key,
                                      attrs: { id: "ssnMessage" },
                                      domProps: { innerHTML: _vm._s(message) }
                                    })
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.formData.ssn,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "ssn", $$v)
                              },
                              expression: "formData.ssn"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-text-field", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: "##/##/####",
                            expression: "'##/##/####'"
                          }
                        ],
                        attrs: {
                          dense: "",
                          filled: "",
                          rounded: "",
                          "validate-on-blur": "",
                          autocomplete: "null",
                          type: "tel",
                          placeholder: "MM/DD/YYYY",
                          rules: _vm.fieldRules.birthDate,
                          "error-messages": _vm.formFieldsErrors.birthDate,
                          id: "birthDate"
                        },
                        on: {
                          focus: function($event) {
                            return _vm.clearFieldError("birthDate")
                          }
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "label",
                            fn: function() {
                              return [
                                _c("p", { staticClass: "input-legend" }, [
                                  _vm._v(_vm._s(_vm.$t("kyc.birthDate")))
                                ])
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "message",
                            fn: function(ref) {
                              var message = ref.message
                              var key = ref.key
                              return [
                                _c("span", {
                                  key: key,
                                  attrs: { id: "birthDateMessage" },
                                  domProps: { innerHTML: _vm._s(message) }
                                })
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.formData.birthDate,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "birthDate", $$v)
                          },
                          expression: "formData.birthDate"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "horizontal-divider" }),
              _vm._v(" "),
              _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "-helper--flex align-center space-between",
                    staticStyle: { "align-items": "baseline" }
                  },
                  [
                    _c(
                      "label",
                      {
                        ref: "ownerAddressSection",
                        staticClass: "form-section-header"
                      },
                      [_vm._v("Owner personal address")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "-helper--flex align-center",
                        staticStyle: { position: "relative" }
                      },
                      [
                        _vm.formData.checkbox
                          ? _c("img", {
                              staticClass: "checkbox-image",
                              attrs: {
                                src: require("../RF_assets/icons/checkmark-lili-blue.svg")
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.formData.checkbox,
                              expression: "formData.checkbox"
                            }
                          ],
                          ref: "elCheckbox",
                          staticClass: "checkbox",
                          attrs: { id: "elCheckBox", type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.formData.checkbox)
                              ? _vm._i(_vm.formData.checkbox, null) > -1
                              : _vm.formData.checkbox
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$a = _vm.formData.checkbox,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.formData,
                                        "checkbox",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.formData,
                                        "checkbox",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.formData, "checkbox", $$c)
                                }
                              },
                              _vm.handleCheck
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("p", { staticClass: "disclaimer" }, [
                          _vm._v("Same as mine")
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-row" },
                  [
                    _c(
                      "div",
                      { staticClass: "line1" },
                      [
                        _c("v-text-field", {
                          attrs: {
                            dense: "",
                            filled: "",
                            rounded: "",
                            autocomplete: "null",
                            rules: _vm.fieldRules.line1,
                            "error-messages": _vm.formFieldsErrors.line1,
                            id: "line1",
                            disabled: _vm.formData.checkbox
                          },
                          on: {
                            focus: function($event) {
                              return _vm.clearFieldError("line1")
                            }
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function() {
                                return [
                                  _c("p", { staticClass: "input-legend" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("addressDetail.line1"))
                                    )
                                  ])
                                ]
                              },
                              proxy: true
                            },
                            {
                              key: "message",
                              fn: function(ref) {
                                var message = ref.message
                                var key = ref.key
                                return [
                                  _c("span", {
                                    key: key,
                                    attrs: { id: "line1Message" },
                                    domProps: { innerHTML: _vm._s(message) }
                                  })
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.formData.line1,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "line1", $$v)
                            },
                            expression: "formData.line1"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-row" },
                      [
                        _c("v-text-field", {
                          staticStyle: { "max-width": "48%" },
                          attrs: {
                            dense: "",
                            filled: "",
                            rounded: "",
                            autocomplete: "null",
                            "error-messages": _vm.formFieldsErrors.line2,
                            id: "line2",
                            disabled: _vm.formData.checkbox
                          },
                          on: {
                            focus: function($event) {
                              return _vm.clearFieldError("line2")
                            }
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function() {
                                return [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "input-legend",
                                      staticStyle: { "font-size": "13px" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("addressDetail.line2"))
                                      )
                                    ]
                                  )
                                ]
                              },
                              proxy: true
                            },
                            {
                              key: "message",
                              fn: function(ref) {
                                var message = ref.message
                                var key = ref.key
                                return [
                                  _c("span", {
                                    key: key,
                                    attrs: { id: "line2Message" },
                                    domProps: { innerHTML: _vm._s(message) }
                                  })
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.formData.line2,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "line2", $$v)
                            },
                            expression: "formData.line2"
                          }
                        }),
                        _vm._v(" "),
                        _vm.isMobile
                          ? _c("v-text-field", {
                              directives: [
                                {
                                  name: "mask",
                                  rawName: "v-mask",
                                  value: "#####",
                                  expression: "'#####'"
                                }
                              ],
                              ref: "postalCode",
                              staticClass: "zip",
                              attrs: {
                                dense: "",
                                filled: "",
                                rounded: "",
                                autocomplete: "null",
                                disabled: _vm.formData.checkbox,
                                rules: _vm.fieldRules.zip,
                                "error-messages":
                                  _vm.formFieldsErrors.postalCode,
                                inputmode: "numeric",
                                id: "postalCode"
                              },
                              on: {
                                focus: function($event) {
                                  return _vm.clearFieldError("postalCode")
                                }
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "label",
                                    fn: function() {
                                      return [
                                        _c(
                                          "p",
                                          { staticClass: "input-legend" },
                                          [
                                            _vm._v(
                                              "\n            " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "addressDetail.postalCode"
                                                  )
                                                ) +
                                                "\n          "
                                            )
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  },
                                  {
                                    key: "message",
                                    fn: function(ref) {
                                      var message = ref.message
                                      var key = ref.key
                                      return [
                                        _c("span", {
                                          key: key,
                                          attrs: { id: "postalCodeMessage" },
                                          domProps: {
                                            innerHTML: _vm._s(message)
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3460234930
                              ),
                              model: {
                                value: _vm.formData.postalCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "postalCode", $$v)
                                },
                                expression: "formData.postalCode"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isMobile
                          ? _c("v-text-field", {
                              staticClass: "city",
                              attrs: {
                                dense: "",
                                filled: "",
                                rounded: "",
                                autocomplete: "null",
                                rules: _vm.fieldRules.city,
                                "error-messages": _vm.formFieldsErrors.city,
                                id: "city",
                                disabled: _vm.formData.checkbox
                              },
                              on: {
                                focus: function($event) {
                                  return _vm.clearFieldError("city")
                                }
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "label",
                                    fn: function() {
                                      return [
                                        _c(
                                          "p",
                                          { staticClass: "input-legend" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("addressDetail.city")
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  },
                                  {
                                    key: "message",
                                    fn: function(ref) {
                                      var message = ref.message
                                      var key = ref.key
                                      return [
                                        _c("span", {
                                          key: key,
                                          attrs: { id: "cityMessage" },
                                          domProps: {
                                            innerHTML: _vm._s(message)
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3044043634
                              ),
                              model: {
                                value: _vm.formData.city,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "city", $$v)
                                },
                                expression: "formData.city"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.isMobile
                      ? _c("v-text-field", {
                          staticClass: "city",
                          attrs: {
                            dense: "",
                            filled: "",
                            rounded: "",
                            autocomplete: "null",
                            rules: _vm.fieldRules.city,
                            "error-messages": _vm.formFieldsErrors.city,
                            id: "city",
                            disabled: _vm.formData.checkbox
                          },
                          on: {
                            focus: function($event) {
                              return _vm.clearFieldError("city")
                            }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "label",
                                fn: function() {
                                  return [
                                    _c("p", { staticClass: "input-legend" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("addressDetail.city"))
                                      )
                                    ])
                                  ]
                                },
                                proxy: true
                              },
                              {
                                key: "message",
                                fn: function(ref) {
                                  var message = ref.message
                                  var key = ref.key
                                  return [
                                    _c("span", {
                                      key: key,
                                      attrs: { id: "cityMessage" },
                                      domProps: { innerHTML: _vm._s(message) }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3044043634
                          ),
                          model: {
                            value: _vm.formData.city,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "city", $$v)
                            },
                            expression: "formData.city"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "-helper--flex align-center space-between relative"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "state relative",
                        attrs: { id: "ubo-state" }
                      },
                      [
                        _c("v-select", {
                          attrs: {
                            items: _vm.businessTypes,
                            "append-icon": "mdi-chevron-down",
                            rules: _vm.fieldRules.state,
                            label: _vm.$t("addressDetail.state"),
                            "item-text": "title",
                            "item-value": "id",
                            filled: "",
                            disabled: _vm.formData.checkbox
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "item",
                              fn: function(data) {
                                return [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "v-list-item__title",
                                      attrs: { id: data.item.id }
                                    },
                                    [_vm._v(_vm._s(data.item.title))]
                                  )
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.formData.state,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "state", $$v)
                            },
                            expression: "formData.state"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.isMobile
                      ? _c("v-text-field", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: "#####",
                              expression: "'#####'"
                            }
                          ],
                          ref: "postalCode",
                          staticClass: "zip",
                          attrs: {
                            dense: "",
                            filled: "",
                            rounded: "",
                            autocomplete: "null",
                            disabled: _vm.formData.checkbox,
                            rules: _vm.fieldRules.zip,
                            "error-messages": _vm.formFieldsErrors.postalCode,
                            inputmode: "numeric",
                            id: "postalCode"
                          },
                          on: {
                            focus: function($event) {
                              return _vm.clearFieldError("postalCode")
                            }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "label",
                                fn: function() {
                                  return [
                                    _c("p", { staticClass: "input-legend" }, [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.$t("addressDetail.postalCode")
                                          ) +
                                          "\n          "
                                      )
                                    ])
                                  ]
                                },
                                proxy: true
                              },
                              {
                                key: "message",
                                fn: function(ref) {
                                  var message = ref.message
                                  var key = ref.key
                                  return [
                                    _c("span", {
                                      key: key,
                                      attrs: { id: "postalCodeMessage" },
                                      domProps: { innerHTML: _vm._s(message) }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3460234930
                          ),
                          model: {
                            value: _vm.formData.postalCode,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "postalCode", $$v)
                            },
                            expression: "formData.postalCode"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "horizontal-divider" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "percentOwned" },
                  [
                    _vm.isSunriseFlow
                      ? _c("v-text-field", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: "##",
                              expression: "'##'"
                            }
                          ],
                          ref: "percentOwned",
                          attrs: {
                            dense: "",
                            filled: "",
                            rounded: "",
                            "validate-on-blur": "",
                            autocomplete: "null",
                            rules: _vm.fieldRules.percentOwned,
                            "error-messages": _vm.formFieldsErrors.percentOwned,
                            inputmode: "numeric",
                            id: "percentOwned",
                            suffix: _vm.formData.percentOwned ? "%" : ""
                          },
                          on: {
                            focus: function($event) {
                              return _vm.clearFieldError("percentOwned")
                            }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "label",
                                fn: function() {
                                  return [
                                    _c("p", { staticClass: "input-legend" }, [
                                      _vm._v(
                                        "\n            Ownership Percentage (%)\n          "
                                      )
                                    ])
                                  ]
                                },
                                proxy: true
                              },
                              {
                                key: "message",
                                fn: function(ref) {
                                  var message = ref.message
                                  var key = ref.key
                                  return [
                                    _c("span", {
                                      key: key,
                                      attrs: { id: "percentOwnedMessage" },
                                      domProps: { innerHTML: _vm._s(message) }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2683970676
                          ),
                          model: {
                            value: _vm.formData.percentOwned,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "percentOwned", $$v)
                            },
                            expression: "formData.percentOwned"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.isMultiUserOnBoardingFeatureOpen
                  ? _c(
                      "div",
                      {
                        staticClass: "add-owner-ubo-container",
                        attrs: { "data-testid": "ubo-access-container-desktop" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "add-owner-ubo",
                            class: {
                              error: _vm.isUBOFieldInvalid()
                            }
                          },
                          [
                            _c(
                              "h3",
                              {
                                attrs: {
                                  "data-testid": "ubo-access-title-desktop"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("add_owner_ubo.title")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "ubo-buttons-wrapper",
                                attrs: {
                                  "data-testid":
                                    "ubo-access-buttons-container-desktop"
                                }
                              },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "ubo-button-yes",
                                    class: {
                                      "is-active": _vm.isUBOPartnerFullAccess()
                                    },
                                    attrs: {
                                      elevation: "0",
                                      type: "button",
                                      id: "add-owner-ubo__yes"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.updateRoleToPartnerFullAccess()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("add_owner_ubo.button_yes")
                                        ) +
                                        "\n            "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "ubo-button-no",
                                    class: {
                                      "is-active": _vm.isUBOPartner()
                                    },
                                    attrs: {
                                      elevation: "0",
                                      type: "button",
                                      id: "add-owner-ubo__no"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.updateRoleToPartner()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("add_owner_ubo.button_no")
                                        ) +
                                        "\n            "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.isUBOFieldInvalid()
                          ? _c(
                              "h3",
                              {
                                staticClass: "add-owner-ubo__error",
                                attrs: {
                                  "data-testid":
                                    "ubo-access-error-field-desktop"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("add_owner_ubo.required")))]
                            )
                          : _vm._e()
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "horizontal-divider" })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "action-wrapper" },
            [
              !_vm.isMobile
                ? _c(
                    "h3",
                    {
                      staticClass:
                        "form-footer-back -helper--flex align-center",
                      attrs: { id: "elNavBackDesktop" },
                      on: { click: _vm.handleBack }
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.$t("navBack")) + "\n      "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "main-app-cta margin-left-auto",
                  class: {
                    "disabled-cta": false,
                    "active-cta": true
                  },
                  attrs: {
                    elevation: "0",
                    loading: _vm.flags.isLoading,
                    type: "submit",
                    id: "elCta"
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.submitForm.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(_vm.$t("submit")) + "\n      ")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.isMobile ? _c("MobileFooter") : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2cc7bfcc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cc7bfcc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/AddOwner.vue
// module id = null
// module chunks = 